import { interpolateRgb } from 'd3-interpolate';
import { color } from 'd3-color';
// import { format } from '../../../lib/utils'

var buildHistogramConfiguration = function buildHistogramConfiguration(widgetConfig, seriesDataObj) {
    var HistogramConfig = widgetConfig.HistogramConfig;
    var XAxisName = HistogramConfig.XAxisName,
        Color = HistogramConfig.Color;


    var data = seriesDataObj.Hist;

    var range = data.reduce(function (acc, d, i) {
        if (!acc.min) acc.min = d;
        if (!acc.max) acc.max = d;

        var min = acc.min < d ? acc.min : d;
        var max = acc.max > d ? acc.max : d;

        return { min: min, max: max };
    }, { min: null, max: null });

    var colorMin = color(Color).brighter();
    var colorMax = color(Color).darker();
    var colorFunction = interpolateRgb(colorMin, colorMax);

    var seriesData = data.map(function (d) {
        return {
            y: d,
            color: colorFunction(d / range.max)
        };
    });

    return {
        name: XAxisName,
        data: seriesData,
        type: 'column',
        tooltip: {
            headerFormat: ''
        }
    };
};

export default buildHistogramConfiguration;